import { render, staticRenderFns } from "./supplier-info.vue?vue&type=template&id=f9ae20c2&scoped=true"
import script from "./supplier-info.vue?vue&type=script&lang=js"
export * from "./supplier-info.vue?vue&type=script&lang=js"
import style0 from "./supplier-info.vue?vue&type=style&index=0&id=f9ae20c2&prod&lang=scss"
import style1 from "./supplier-info.vue?vue&type=style&index=1&id=f9ae20c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae20c2",
  null
  
)

export default component.exports